var _global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

_global.SENTRY_RELEASE = {
  id: "fcf0e244bf45d54aaffd76f8a0b2da85ee565d08"
};
_global.SENTRY_RELEASES = _global.SENTRY_RELEASES || {};
_global.SENTRY_RELEASES["percko@percko"] = {
  id: "fcf0e244bf45d54aaffd76f8a0b2da85ee565d08"
};